// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2913y","rootCenter":"LoadMoreObserver_rootCenter__1wAiF","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3ZjpV"};